import {computed} from "vue";

export const PreviewHelper = (props) => {

	const bgColor = computed(() => {
		return props.selectedItems.background_color ? props.selectedItems.background_color.value : false
	});

	const starMapColor = computed(() => {
		return props.selectedItems.star_map_color ? props.selectedItems.star_map_color.value : false
	});
	const starMapColorHex = computed(() => {
		return starMapColor.value ? `${starMapColor.value }` : '';
  });

	const textColor = computed(() => {
		return bgColor.value && bgColor.value === starMapColor.value ? '#ffffff' : `${starMapColor.value}`;
	});

	const starMapBorderCircle = computed(() => {
		var output = {
			bgColor: "transparent",
			width: 0
		}

		return output;
	});

	return {
		bgColor,
		starMapColor,
		textColor,
		starMapBorderCircle,
    	starMapColorHex
	}
}
